import * as R from 'remeda'

/**
 * 配列とテスト関数を取り、テスト関数が真を返す要素を除外した新しい配列を返します。
 *
 * @template T - 配列内の値の型。
 * @param items - 配列。
 * @param fn - テスト関数。
 * @returns 結果の配列。
 */
export function reject<T>(items: T[], fn: (item: T) => boolean): T[]

/**
 * テスト関数を取り、テスト関数が真を返す要素を除外した新しい配列を返す関数を返します。
 *
 * @template T - 配列内の値の型。
 * @param fn - テスト関数。
 * @returns 関数。
 */
export function reject<T>(fn: (item: T) => boolean): (items: T[]) => T[]

/**
 * @param args - 引数。
 * @returns 結果または部分適用された関数。
 */
export function reject<T>(
  ...args: [fn: (item: T) => boolean] | [items: T[], fn: (item: T) => boolean]
): T[] | ((items: T[]) => T[]) {
  const rejectInner = (items: T[], fn: (item: T) => boolean) =>
    R.filter(items, R.isNot(fn))

  if (args.length === 1) {
    return (items: T[]) => rejectInner(items, args[0])
  }

  return rejectInner(...args)
}
